const serverUri = process.env.REACT_APP_SERVER_URI;

export default serverUri;
